//store	-	index.js


import { createStore } from 'vuex';

export default createStore({
  state: {
	counter: 0, 
	selectedVariant: '',
	testValue: 'Test', 
	carbonRate: '',
	carbonValue: '',
	flightCount: '', 
	buildingResult: {},
	ctx: 0,
	showResultBar: false,
	lineChart: 'carbonData',
	columnLoadExceeded: false,

	buildingResults: [],

	// buildingResults: [ 
	// 	{
	// 		material: "Steel",
	// 		system: "Holrib Slab",
	// 		grid: "5.71 m x 6.00 m",
	// 		load: 1.5,
	// 		surfaceArea: 2000,
	// 		clearFloorHeight: 4.86,
	// 		structCeilingHeight: "0.28",
	// 		weight: 21824,
	// 		cost: 590327,
	// 		carbonData: 6347935,
	// 		// carbonData: {
	// 		// 	total: 5347935
	// 		// }
	// 	},
	// 	{
	// 		material: "Concrete",
	// 		system: "Flat Slab",
	// 		grid: "6.71 m x 6.00 m",
	// 		load: 3.5,
	// 		surfaceArea: 2000,
	// 		clearFloorHeight: 4.6,
	// 		structCeilingHeight: "0.4",
	// 		weight: 23041,
	// 		cost: 734359,
	// 		carbonData: 567935,
	// 		// carbonData: {
	// 		// 	total: 567935
	// 		// }
	// 	},
	// 	{
	// 		material: "Timber",
	// 		system: "Ribbed Timber Slab",
	// 		grid: "5.61 m x 7.00 m",
	// 		load: 2.5,
	// 		surfaceArea: 2000,
	// 		clearFloorHeight: 4.5,
	// 		structCeilingHeight: "0.5",
	// 		weight: 24031,
	// 		cost: 678459,
	// 		carbonData: 454935,
	// 		// carbonData: {
	// 		// 	total: 426912
	// 		// }		
	// 	},
	// 	{
	// 		material: "Hybrid",
	// 		system: "HBV Ribbed Slab",
	// 		grid: "4.71 m x 8.00 m",
	// 		load: 1.8,
	// 		surfaceArea: 2000,
	// 		clearFloorHeight: 4.2,
	// 		structCeilingHeight: "0.8",
	// 		weight: 38011,
	// 		cost: 535459,
	// 		carbonData: 345935,
	// 		// carbonData: {
	// 		// 	total: 345935
	// 		// }
	// 	},
	// 	{
	// 		material: "Concrete",
	// 		system: "T-Beams",
	// 		grid: "6.71 m x 7.00 m",
	// 		load: 2.8,
	// 		surfaceArea: 2000,
	// 		clearFloorHeight: 3.8,
	// 		structCeilingHeight: "0.5",
	// 		weight: 45929,
	// 		cost: 459292,
	// 		carbonData: 355935,
	// 		// carbonData: {
	// 		// 	total: 456828
	// 		// }
	// 	},
	// 	{
	// 		material: "Steel",
	// 		system: "Composite",
	// 		grid: "4.71 m x 8.00 m",
	// 		load: 1.2,
	// 		surfaceArea: 2000,
	// 		clearFloorHeight: 3.2,
	// 		structCeilingHeight: "0.2",
	// 		weight: 23494,
	// 		cost: 345090,
	// 		carbonData: 145935,
	// 		// carbonData: {
	// 		// 	total: 234909
	// 		// }
	// 	}
	// ],

	// databaseMaterial: {
	// 	concrete: {
	// 		costs: 6, 
	// 		carbon: 6
	// 	},
	// 	reinforcementBars: {
	// 		costs: 6, 
	// 		carbon: 6
	// 	},
	// 	formwork: {
	// 		costs: 6
	// 	},
	// 	steel: {
	// 		costs: 6, 
	// 		carbon: 6
	// 	},
	// 	profileSteelSheet: {
	// 		costs: 6, 
	// 		carbon: 6
	// 	},
	// 	timberCLT: {
	// 		costs: 6, 
	// 		carbon: 6
	// 	},
	// 	timberGLh: {
	// 		costs: 6, 
	// 		carbon: 6
	// 	}
	// },

	databaseMaterial: {
		concrete: {
			costs: 170, 
			carbon: 342
		},
		reinforcementBars: {
			costs: 1.55, 
			carbon: 1.99
		},
		formwork: {
			costs: 42
		},
		steel: {
			costs: 2.8, 
			carbon: 1.55
		},
		profileSteelSheet: {
			costs: 4, 
			carbon: 2.76
		},
		timberCLT: {
			costs: 600, 
			carbon: 206.96
		},
		timberGLh: {
			costs: 800, 
			carbon: 225.28
		}
	},
	
  },
  mutations: {
	increaseCounter(state) {
		state.counter ++;
	},
	addResult(state, buildingResult) {
		state.buildingResults.push(buildingResult);
		console.log('buildingResult from addResult mutation'); 
		console.log(buildingResult); 
	}
  },
  actions: {
  },
  getters: {
	getCarbonRate(state) {
		var rate; 

		var carbonRate = state.carbonRate;

		if(carbonRate == 'A++') {
			rate = 'A++_rate';
		}
		else if(carbonRate == 'A+') {
			rate = 'A+_rate';
		}
		else if(carbonRate == 'A') {
			rate = 'A_rate';
		}
		else if(carbonRate == 'B') {
			rate = 'B_rate';
		}
		else if(carbonRate == 'C') {
			rate = 'C_rate';
		}
		else if(carbonRate == 'D') {
			rate = 'D_rate';
		}
		else if(carbonRate == 'E') {
			rate = 'E_rate';
		}
		else if(carbonRate == 'F') {
			rate = 'F_rate';
		}
		else {
			rate = 'G_rate';
		}

		return rate;
	}
  },
  modules: {
  }
})
